import { useState } from "react";
import { ALLOWED_DOMAINS, signInWithGoogle } from "../lib/firebase";

export default function Login() {
  const [error, setError] = useState<string | null>(null);

  async function handleSignIn() {
    setError(null);
    try {
      await signInWithGoogle();
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink px-6">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex flex-col items-center text-center">
          <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-[14px] bg-white">
            <img src="/v_transparent.png" alt="" className="h-11 w-11 object-contain" />
          </div>
          <div className="font-light tracking-[0.08em] text-3xl text-[#e7e8e4]">
            CHICAGO&nbsp;<span className="font-normal text-signature text-[1.14em]">V</span>ENTURE
          </div>
          <div className="mt-2 font-mono text-[11px] tracking-[0.4em] text-faint">PARTNERS</div>
          <div className="mt-6 font-mono text-xs tracking-[0.14em] uppercase text-muted">
            Closing Checklists
          </div>
        </div>
        <button
          onClick={() => void handleSignIn()}
          className="w-full rounded-md bg-signature px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-signature-deep"
        >
          Sign in with Google
        </button>
        <p className="mt-4 text-center font-mono text-[10px] leading-relaxed text-muted">
          Restricted to {ALLOWED_DOMAINS.map((d) => `@${d}`).join(" and ")} accounts
        </p>
        {error && (
          <p className="mt-4 text-center font-mono text-[11px] text-signature">{error}</p>
        )}
      </div>
    </div>
  );
}
